<template>
    <div
        :class="[
            'button-container',
            float ? 'fixed md:static bottom-0 left-0 right-0 p-4' : ' p-4',
        ]">
        <div :class="[buttonWrapperClasses]">
            <button
                class="action-btn flex items-center justify-center space-x-2 p-4 relative flex-1 self-stretch flex-grow-1 text-text-on-background rounded-md overflow-hidden w-full"
                :class="[
                    props?.buttonData?.disabled
                        ? 'bg-[#D0D0D0] pointer-events-none'
                        : 'bg-[#e40032]',
                ]"
                @click="handleButtonClick"
                :disabled="buttonData?.disabled">
                <div
                    class="text-wrapper relative var-font-family whitespace-normal font-[--WEB-all-button-large-font-weight] text-[--colour-theme-text-text-on-background] var-line-height mt--1 w-fit md:whitespace-nowrap leading-6"
                    :style="buttonTextStyles">
                    {{ props.buttonData.text }}
                </div>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { IButton } from '@/components/ComponentTypes';

    const props = defineProps<IButton>();

    const handleButtonClick = async () => {
        if (props.buttonData?.newTab && props.buttonData.page) {
            await navigateTo(props.buttonData.page, {
                external: true,
                target: '_blank',
            });
        }
        if (props.buttonData.page) {
            await navigateTo(props.buttonData.page);
        }
    };
</script>
